import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
  { field: 'id', headerName: 'Transaction ID', flex: 0.15, minWidth: 100 },
  { field: 'customer_id', headerName: 'Customer ID', flex: 0.15, minWidth: 100 },
  { field: 'dst_customer_id', headerName: 'Dest. Customer ID', flex: 0.15, minWidth: 100 },
  { field: 'txn_date', headerName: 'Date', flex: 0.15, minWidth: 120 },
  { field: 'amount', headerName: 'Amount', flex: 0.15, minWidth: 100 },
  { field: 'dst_country', headerName: 'Dest. Country', flex: 0.15, minWidth: 100 },
  { field: 'swift_code', headerName: 'SWIFT Code', flex: 0.15, minWidth: 100 },
];

const PinnedTransactionsDocument = ({ open, onClose, caseId }) => {
  const pinnedTransactions = JSON.parse(localStorage.getItem('pinnedTransactions') || '{}');
  const transactions = pinnedTransactions[caseId] || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Pinned Transactions for Case {caseId}</DialogTitle>
      <DialogContent>
        {transactions.length === 0 ? (
          <Typography>No pinned transactions for this case.</Typography>
        ) : (
          <Box sx={{ height: 400, width: '100%' }}>
            <DataGrid
              rows={transactions}
              columns={columns}
              getRowId={(row) => row.id}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              disableSelectionOnClick
              sx={{
                backgroundColor: 'background.paper',
                color: 'text.primary',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: 'background.default',
                  color: 'text.primary',
                },
                '& .MuiDataGrid-cell': { color: 'text.primary' },
                '& .MuiDataGrid-row': {
                  backgroundColor: 'background.paper',
                  '&:hover': { backgroundColor: 'action.hover' },
                },
                '& .MuiDataGrid-footerContainer': {
                  backgroundColor: 'background.default',
                  color: 'text.primary',
                },
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PinnedTransactionsDocument;